import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export function MobileLiner24(param) {
    let { color = 'currentColor' } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.8181 5.18182H10.1818",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "5.47729",
                y: "2.75",
                width: "13.0455",
                height: "18.5",
                rx: "3.25",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
}
